<script>
import LeslycVipRoulette from "@homepage/components/roulette2d/LeslycVipRoulette.vue";
import PageStyle from "@/enumerations/PageStyle.json"
import {fetchSortitionResult} from "@/api/v2/board.api";
import throttle from 'lodash/throttle'
import ResultField from '@/enumerations/ResultField.json'

const mapServerResultToRouletteFormatResult = (result) => {
	const numbers = []

	if (result.pickTwo) {
		numbers.push({
			playType: {
				id: ResultField.PickTwo,
				name: 'Pick 2'
			},
			digits: String(result.pickTwo).padStart(2, '0')
		})
	}

	if (result.cashThree) {
		numbers.push({
			playType: {
				id: ResultField.CashThree,
				name: 'Cash 3'
			},
			digits: String(result.cashThree).padStart(3, '0')
		})
	}

	if (result.pickFour) {
		numbers.push({
			playType: {
				id: ResultField.PickFour,
				name: 'Pick 4'
			},
			digits: String(result.pickFour).padStart(4, '0')
		})
	}

	if (result.pickFive) {
		numbers.push({
			playType: {
				id: ResultField.PickFive,
				name: 'Pick 5'
			},
			digits: String(result.pickFive).padStart(5, '0')
		})
	}

	return numbers;
}

export default {
	name: "SlotMachine",
	components: {
		LeslycVipRoulette,
	},
	props: {
		apiToken: {
			type: String,
			required: false,
			default: null
		},
		sortition: {
			type: Object,
			required: true,
		},
		pageStyle: {
			type: Number,
			required: true,
		}
	},
	created() {
		console.log("SlotMachine created");
		this.fetchResult = throttle(this.fetchResult, 5000, {trailing: true});

		const FIVE_MINUTES = 5 * 60 * 1000;

		this.fetchResult()

		this.resultFetchTimeout = setTimeout(() => {
			this.onFinish();
		},FIVE_MINUTES)
	},
	data() {
		return {
			PageStyle,
			resultFetched: false,
			fetchingResult: false,
			result: null,
			resultFetchTimeout: null,
		}
	},
	methods: {
		fetchResult() {
			if (this.fetchingResult === false) {
				this.fetchingResult = true;
				fetchSortitionResult({sortitionId: this.sortition.id, apiToken: this.apiToken}).then((response) => {
					if (response.data.result !== null) {
						clearTimeout(this.resultFetchTimeout);
						this.result = {
							sortition: this.sortition.name,
							numbers: mapServerResultToRouletteFormatResult(response.data.result)
						};
						this.resultFetched = true;
					}
				}).finally(() => {
					this.fetchingResult = false;

					this.$nextTick(() => {
						if (this.resultFetched === false) {
							this.fetchResult();
						}
					})
				})
			}
		},
		onFinish() {
			this.$router.push({
				name: 'board',
				query: {
					apiToken: this.apiToken
				}
			});
		}
	}
}
</script>

<template>
	<v-row>
		<v-col cols="4" offset="4">
			<leslyc-vip-roulette v-if="resultFetched && result" :result="result" @finish="onFinish"></leslyc-vip-roulette>
			<div class="d-flex" v-else>
				<div>
					<v-img contain :src="require('@/assets/img/leslycvip/logo.png')" width="400px"></v-img>
					<div class="text-center text-h3">
						Welcome back!
					</div>
				</div>
			</div>
		</v-col>
	</v-row>
</template>

<style scoped lang="scss">

</style>
